export default "__VITE_ASSET__erRESJ2y__"